import { DrawerMenuItem } from "components/basic/drawer";
import { TFunction } from "i18next";
import { HeaderItem } from "components/basic/header";

interface ProjectService extends HeaderItem {
  /**
   * Only built tools are advertised. The rest still resolve to a placeholder
   * div, so linking to them just walks the visitor into an empty page — they
   * stay listed here so turning one on is a one-word change once it exists.
   */
  ready: boolean;
}

const allProjectServices: ProjectService[] = [
  {
    label: "tools.calculator",
    shortenedLabel: "tools.calculator_short",
    path: "/calculator",
    ready: true,
  },
  {
    label: "tools.charger_estimator",
    shortenedLabel: "tools.charger_estimator_short",
    path: "/chargerEstimator",
    ready: true,
  },
  {
    label: "tools.browser",
    shortenedLabel: "tools.browser_short",
    path: "/browser",
    ready: false,
  },
  {
    label: "tools.incentives",
    shortenedLabel: "tools.incentives_short",
    path: "/incentives",
    ready: false,
  },
  {
    label: "tools.industry_map",
    shortenedLabel: "tools.industry_map_short",
    path: "/industryMap",
    ready: false,
  },
  {
    label: "tools.service_providers",
    shortenedLabel: "tools.service_providers_short",
    path: "/serviceProviders",
    ready: false,
  },
  {
    label: "tools.sustainability_tracker",
    shortenedLabel: "tools.sustainability_tracker_short",
    path: "/sustainabilityTracker",
    ready: false,
  },
];

const projectServices = (): HeaderItem[] =>
  allProjectServices.filter(({ ready }) => ready);

const rightDrawerOptions = (t: TFunction<"common">): DrawerMenuItem[] => [
  { label: t("nav.about").toUpperCase(), path: "/about" },
  { label: t("nav.dashboard").toUpperCase(), path: "/dashboard" },
  {
    label: t("nav.tools").toUpperCase(),
    path: "",
    childItems: projectServices().map(({ shortenedLabel, path }) => ({
      label: t(shortenedLabel).toUpperCase(),
      path,
    })),
  },
  { label: t("nav.contact").toUpperCase(), path: "/contact" },
  // There is no footer in this layout, and the policy has to be reachable from
  // anywhere on the site, so it lives in the only persistent navigation.
  { label: t("nav.privacy").toUpperCase(), path: "/privacy" },
];

const numberWithCommas = (number: number): String => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export function formatDollars(amount: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export { rightDrawerOptions, projectServices, numberWithCommas };
